'use client';

import { type ReactNode } from 'react';
import { useAuth } from '@/contexts';
import { isMasterAdmin } from '@/contexts/auth/isMasterAdmin';
import { Button, Typography } from '@mui/material';
import { useRouter } from 'next/navigation';
import { useTranslations } from 'next-intl';
import styled from 'styled-components';

const AccessDeniedWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  gap: 16px;
  text-align: center;
  padding: 0 16px;
`;

export const MasterAdminGuard = ({ children }: { children: ReactNode }) => {
  const t = useTranslations('masterAdmin');
  const { user, isAuthenticated } = useAuth();
  const router = useRouter();

  if (!isAuthenticated || !user) return null;

  if (!isMasterAdmin(user.role)) {
    return (
      <AccessDeniedWrapper>
        <Typography variant="h4" fontWeight={700}>
          {t('accessDeniedTitle')}
        </Typography>
        <Typography variant="body1" color="text.secondary" maxWidth={480}>
          {t('accessDeniedBody')}
        </Typography>
        <Button variant="contained" onClick={() => router.back()}>
          {t('accessDeniedBack')}
        </Button>
      </AccessDeniedWrapper>
    );
  }

  return <>{children}</>;
};
